// The `Refunds` component is a React functional component that displays refund policy details using a
// clean and structured layout. It accepts `contentData` of type `ReturnPolicy` and renders the service name,
// refund policy description, and FAQ section. The FAQ section uses an accordion button (`AccordionBtn`) to display
// questions and answers interactively, enhancing user engagement. Markdown content is rendered with the `MarkDownDescription`
// component for rich text formatting, ensuring a polished presentation.

import { MarkDownDescription } from 'components/commercetools-ui/atoms/markdown/markdown';
import React from 'react';
import { ReturnPolicy, ServiceFAQ } from 'types/next';
import AccordionBtn from 'components/commercetools-ui/atoms/accordion';

interface RefundsProps {
  contentData: ReturnPolicy;
}

const Refunds = ({ contentData }: RefundsProps) => {
  return (
    <>
      {contentData && (
        <>
          <h1 className="mb-30 font-body text-[36px] font-bold leading-9">{contentData?.serviceName}</h1>
          <MarkDownDescription markdownText={contentData?.returnPolicy} classname="mb-20 return" />
          <h3 className="mb-20 font-body text-28 font-normal leading-7">{contentData?.returnType?.heading}</h3>
          <hr />
          {contentData?.returnType?.faqs &&
            contentData?.returnType?.faqs?.[0]?.faqs.map((faq: ServiceFAQ, index: number) => {
              return (
                <AccordionBtn
                  variant="plusAndMinus"
                  className="items-center border-b border-[#d1c9c4] py-15 text-16 font-semibold"
                  closedSectionTitle={faq.question}
                  panelClassName="text-primary-black pt-10"
                  key={index}
                >
                  <div>{faq.answer}</div>
                </AccordionBtn>
              );
            })}
        </>
      )}
    </>
  );
};

export default Refunds;
